module.exports = "/images/AL.png?47ec3d33b06f3d39aad11450bf41806e";